// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"ET5QtG","menuItems":"_31bYuH","menuItem":"_3L2N65","avatar":"_2vKqSF"};